import { CSSObject } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const datePickerWrapper: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  '.kuiper-select-trigger.kuiper-light': {
    border: `1px solid ${colors.n9.base}`,
    backgroundColor: colors.n9.base,
  },
  '.kuiper-input input[type=text], .kuiper-input-element': {
    paddingBottom: '8px',
    fontFamily: fonts.sourceCode,
  },
}

const calendarIcon: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  marginRight: '9px',
  '.kuiper-icon-wrapper': {
    color: colors.n7.base,
    cursor: 'pointer',
    '&:hover': {
      color: colors.n5.base,
    },
  },
}

const ampmToggleInputWrapper: CSSObject = {
  marginRight: '8px',
}

const timeInput: CSSObject = {
  marginRight: '8px',
  width: '55px',
}

const styles = {
  ampmToggleInputWrapper,
  datePickerWrapper,
  calendarIcon,
  timeInput,
}

export { styles }
